import { render, staticRenderFns } from "./PrintDataItems.vue?vue&type=template&id=49d87582&"
import script from "./PrintDataItems.vue?vue&type=script&lang=js&"
export * from "./PrintDataItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports